import { useContext, useState } from "react";
import { Document, Page } from "react-pdf";
import TradingPlan from "./plan.pdf";
import ThemeContext from "../../lib/theme-context";
import useWindowDimensions from "../../utils/width";
require("pdfjs-dist/build/pdf.worker.entry.js");

const Plan = () => {
  const theme = useContext(ThemeContext);
  const { width } = useWindowDimensions();
  const [numPages, setNumPages] = useState(null);

  const Loader = () => {
    return (
      <div>
        <p></p>
      </div>
    );
  };

  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
  };

  const workOutWidth = () => {
    if (width < 500) {
      return 430;
    } else if ((width > 501) && (width < 999)) {
      return 790;
    } else if (width > 1000) {
      return 980;
    }
  };

  return (
    <div
      style={{
        width: "100vw",
        height: "100%",
        display: "flex",
        alignItems: "center !important",
        justifyContent: "center",
        backgroundColor: theme[0] === "dark" ? "rgba(40, 42, 46)" : "#FCFCFF",
        margin: "auto",
      }}
    >
      <Document 
        file={TradingPlan} 
        loading={<Loader />}
        onLoadSuccess={onDocumentLoadSuccess}
      >
        {numPages && Array.from(new Array(numPages), (el, index) => (
          <Page
            key={`page_${index + 1}`}
            width={workOutWidth()}
            pageNumber={index + 1}
            scale={1}
            renderAnnotationLayer={false}
            renderTextLayer={false}
          />
        ))}
      </Document>
    </div>
  );
};

export default Plan;
